<template>
    <div class="spinner-wrapper">
        <div class="modern-spinner"></div>
    </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";

.spinner-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px 0;
}
.modern-spinner {
    width: 32px;
    height: 32px;
    border: 3px solid $gray200;
    border-top-color: $primaryColor;
    border-radius: 50%;
    animation: spin 0.7s linear infinite;
}
@keyframes spin {
    to { transform: rotate(360deg); }
}
</style>
